(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/ticker-promo-text/assets/javascripts/ticker-promo-text.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/ticker-promo-text/assets/javascripts/ticker-promo-text.js');
"use strict";


const {
  Ticker
} = svs.bingo_react.components;
const {
  BingoLetters
} = svs.bingo_react.components;
const {
  promoTickerTexts
} = svs.bingo_react.data.tickerTextConfig;
const {
  BingoLogotypeLetters
} = svs.bingo_react.components.common.constants;
const TickerPromoText = () => {
  if (!promoTickerTexts.length) {
    return null;
  }
  return React.createElement(Ticker, null, promoTickerTexts.map((text, index) =>
  React.createElement("div", {
    className: "bingo-scroller-container__scroller-content__item",
    key: "".concat(text, "-").concat(index)
  }, React.createElement(BingoLetters, {
    letters: BingoLogotypeLetters
  }), React.createElement("span", null, text))));
};
setGlobal('svs.bingo_react.components.TickerPromoText', TickerPromoText);

 })(window);